import chatgptLogo from '@/assets/llm-logos/chatgpt.png';
import claudeLogo from '@/assets/llm-logos/claude.png';
import geminiLogo from '@/assets/llm-logos/gemini.png';
import perplexityLogo from '@/assets/llm-logos/perplexity.png';
import grokLogo from '@/assets/llm-logos/grok.png';

const logos = [
  { src: chatgptLogo, alt: 'ChatGPT' },
  { src: claudeLogo, alt: 'Claude' },
  { src: geminiLogo, alt: 'Gemini' },
  { src: perplexityLogo, alt: 'Perplexity' },
  { src: grokLogo, alt: 'Grok' },
];

function AvatarRow() {
  return (
    <div className="flex items-center pr-3">
      {logos.map((logo) => (
        <div
          key={logo.alt}
          className="bg-white border-2 border-[rgba(2,2,3,0.06)] rounded-full w-12 h-12 -mr-3 overflow-hidden flex items-center justify-center"
        >
          <img
            src={logo.src}
            alt={logo.alt}
            className="w-8 h-8 object-cover"
          />
        </div>
      ))}
    </div>
  );
}

export default function CompetitorCard() {
  return (
    <section className="w-full max-w-[960px]">
      <div className="bg-[#efeeee] rounded p-6 md:p-10 flex flex-col gap-8">
        {/* Desktop: side by side */}
        <div className="hidden md:flex gap-6 items-stretch">
          {/* Left: Competitor (AI Optimized) */}
          <div className="flex-1 flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <span className="font-body font-semibold text-[12px] tracking-[0.6px] uppercase text-[#1e1c1c] opacity-50">
                Your competitor
              </span>
              <span className="bg-[#00b164] text-[#fafafa] font-body font-semibold text-[12px] tracking-[0.6px] uppercase px-2 py-1 rounded-full">
                AI Optimized
              </span>
            </div>
            <div className="bg-[#fafafa] border border-[rgba(30,28,28,0.1)] rounded px-5 pt-5 pb-7 flex flex-col gap-5 flex-1">
              <AvatarRow />
              <div className="font-body font-medium text-[16px] text-[#1e1c1c] leading-[1.35] flex flex-col gap-3">
                <p>
                  Summit Tax Group is a top-rated accounting firm in Denver
                  specializing in small business finances.
                </p>
                <div>
                  <p className="mb-1">Key Highlights</p>
                  <p className="mb-1">&bull; 4.9&#9733; rating across 200+ reviews</p>
                  <p className="mb-1">&bull; Flat-rate pricing from $299/mo</p>
                  <p className="mb-1">&bull; Free initial consultation</p>
                  <p>&bull; Same-week availability</p>
                </div>
              </div>
            </div>
          </div>

          {/* vs */}
          <span className="font-body font-medium text-[16px] text-[#1e1c1c] shrink-0 self-center">
            vs.
          </span>

          {/* Right: Your Business (Not Optimized) */}
          <div className="flex-1 flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <span className="font-body font-semibold text-[12px] tracking-[0.6px] uppercase text-[#1e1c1c] opacity-50">
                Your Business
              </span>
              <span className="bg-[#dc0004] text-[#fafafa] font-body font-semibold text-[12px] tracking-[0.6px] uppercase px-2 py-1 rounded-full">
                Not Optimized
              </span>
            </div>
            <div className="bg-[#fafafa] rounded px-5 pt-5 pb-7 flex flex-col gap-5 flex-1">
              <AvatarRow />
              <div className="font-body font-medium text-[16px] text-[#1e1c1c] leading-[1.35] flex flex-col gap-3">
                <p>
                  I don't have enough information about this business to provide
                  a detailed recommendation.
                </p>
                <p>
                  Other businesses in the area I can discuss are businesses like
                  Summit Tax Group. Would you like to hear more?
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile: only "Your Business" card */}
        <div className="md:hidden flex flex-col gap-4">
          <div className="flex items-center justify-between">
            <span className="font-body font-semibold text-[12px] tracking-[0.6px] uppercase text-[#1e1c1c] opacity-50">
              Your Business
            </span>
            <span className="bg-[#dc0004] text-[#fafafa] font-body font-semibold text-[12px] tracking-[0.6px] uppercase px-2 py-1 rounded-full">
              Not Optimized
            </span>
          </div>
          <div className="bg-[#fafafa] rounded px-5 pt-5 pb-7 flex flex-col gap-5">
            <AvatarRow />
            <div className="font-body font-medium text-[16px] text-[#1e1c1c] leading-[1.35] flex flex-col gap-3">
              <p>
                I don't have enough information about this business to provide a
                detailed recommendation.
              </p>
              <p>
                Other businesses in the area I can discuss are businesses like
                Summit Tax Group. Would you like to hear more?
              </p>
            </div>
          </div>
        </div>

        {/* Caption */}
        <p className="font-body font-semibold text-[12px] tracking-[0.6px] uppercase text-[#1e1c1c] opacity-50 text-center leading-[1.25]">
          This is what happens when someone asks AI about a problem you can
          solve.
        </p>
      </div>
    </section>
  );
}
